import {Keys} from "@/constants/key";
import BBCodeText from 'phaser3-rex-plugins/plugins/bbcodetext.js';
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class TextPanel extends Phaser.GameObjects.Container {

    private contentText!: BBCodeText;

    constructor(scene: Phaser.Scene, content: string, align: 'left' | 'center' = 'left') {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, 700 * CU.S);

        this.add(back);
        content = content.replace('[img', '[' + Tr('pict.not.sup') + ']');

        this.contentText = new BBCodeText(scene, (align === 'left' ? 20 : 300) * CU.S, 30, content, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            align: align,
            wrap: {
                mode: 1,
                width: 550
            }
        }).setScale(CU.S, CU.S);

        if (align === 'center') {
            this.contentText.setOrigin(0.5, 0);
        }

        // let sep = SpriteUtils.addSprite(this.scene, 300, this.contentText.getBottomCenter().y + 55, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR);

        this.height = this.contentText.getBottomCenter().y / CU.S + 55;

        this.add([this.contentText]);
    }

    public updateText(txt: string) {
        txt = txt.replace('[img', '[' + Tr('pict.not.sup') + ']');
        this.contentText.setText(txt);
        this.height = this.contentText.getBottomCenter().y / CU.S + 55;
    }
}
